export const BULK_SETTLEMENT_DEFAULT_COMMENT = 'Bulk Settlement';
